import {Comparator} from "../../../types/GenericTypes";
import {ascending} from "../../../js/util/UtilFunctions";

export interface RecentPortfolio {
    readonly id: number;
    readonly name: string;
    readonly favourite: boolean;
}

export function sortAscending(): Comparator<RecentPortfolio> {
    return (a, b) => ascending(a.name, b.name);
}
